import { Component, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { distinctUntilChanged, Subject, takeUntil } from 'rxjs';
import { IBrandDetails } from 'src/app/core/domain/brand.model';
import { getBrandDetails } from 'src/app/core/state/global';

@Component({
  selector: 'app-protected-layout-footer',
  templateUrl: './protected-layout-footer.component.html',
  styleUrls: ['./protected-layout-footer.component.scss']
})
export class ProtectedLayoutFooterComponent implements OnInit, OnDestroy {

  currentYear: string;
  brandDetails: Partial<IBrandDetails>;
  private destroyed$: Subject<void> = new Subject();

  constructor(private readonly store: Store) { }

  ngOnInit(): void {
    this.currentYear = new Date().getFullYear().toString();

    this.store.pipe(select(getBrandDetails)).pipe(distinctUntilChanged(), takeUntil(this.destroyed$)).subscribe((res) => {
      if (res) {
        this.brandDetails = res;
      }
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  scrollToTop() {
    window.scrollTo(0, 0);
  }

}
